var map = {
	"./en/MIS_report_config.json": [
		47396,
		7396
	],
	"./en/Packagebilling.json": [
		77156,
		7156
	],
	"./en/aiGrading_config.json": [
		17598,
		7598
	],
	"./en/andrology_config.json": [
		44285,
		4285
	],
	"./en/appointment_form.json": [
		84531,
		4531
	],
	"./en/billing_config.json": [
		76805,
		6805
	],
	"./en/calendar.json": [
		29785,
		9785
	],
	"./en/cima.json": [
		14369,
		6750
	],
	"./en/clinic_config.json": [
		86046,
		6046
	],
	"./en/concent_config.json": [
		4034,
		4034
	],
	"./en/consent_config.json": [
		95570,
		5570
	],
	"./en/cryoThawing_config.json": [
		8425,
		8425
	],
	"./en/cryo_storage_embryo.json": [
		88395,
		8395
	],
	"./en/cryo_storage_oocyte.json": [
		23068,
		3068
	],
	"./en/cryo_storage_sperm.json": [
		21024,
		1024
	],
	"./en/culture_config.json": [
		43122,
		3122
	],
	"./en/cycleOverview_config.json": [
		23796,
		1415
	],
	"./en/dashboard_config.json": [
		87364,
		7364
	],
	"./en/documents_config.json": [
		23022,
		3022
	],
	"./en/examination_config.json": [
		72055,
		2055
	],
	"./en/expired_return.json": [
		8219,
		8219
	],
	"./en/general.json": [
		51329,
		1329
	],
	"./en/grn_config.json": [
		19167,
		9167
	],
	"./en/grn_return.json": [
		48823,
		8823
	],
	"./en/hpi_config.json": [
		13369,
		3369
	],
	"./en/inventory_approval_config.json": [
		99764,
		9764
	],
	"./en/investigation_config.json": [
		22650,
		2650
	],
	"./en/invoice_gallery.json": [
		53255,
		3255
	],
	"./en/issue_return.json": [
		72269,
		2269
	],
	"./en/login.json": [
		30788,
		788
	],
	"./en/material_consumption.json": [
		43714,
		3714
	],
	"./en/material_information.json": [
		28135,
		8135
	],
	"./en/medicalHistorySummary_config.json": [
		64361,
		4361
	],
	"./en/medicalHistory_config.json": [
		52053,
		2053
	],
	"./en/medicalHistrorySummary_config.json": [
		32567,
		2567
	],
	"./en/oocyte_grading.json": [
		6989,
		6989
	],
	"./en/outcome_config.json": [
		51728,
		1728
	],
	"./en/patientList_config.json": [
		41615,
		1615
	],
	"./en/pgt_config.json": [
		62861,
		2861
	],
	"./en/purchase_order.json": [
		1207,
		1207
	],
	"./en/purchase_requisition.json": [
		36191,
		6191
	],
	"./en/receive_return.json": [
		19747,
		9747
	],
	"./en/registration_lang.json": [
		71487,
		1487
	],
	"./en/registration_patient_details.json": [
		89425,
		9425
	],
	"./en/return_config.json": [
		71184,
		1184
	],
	"./en/rfid_config.json": [
		76981,
		6981
	],
	"./en/sales_return.json": [
		97728,
		7728
	],
	"./en/sidebar_config.json": [
		1396,
		1396
	],
	"./en/stimulation_config.json": [
		26327,
		6327
	],
	"./en/stockTransfer_config.json": [
		24599,
		4599
	],
	"./en/stock_adjustment_config.json": [
		38650,
		8650
	],
	"./en/stock_config.json": [
		50686,
		686
	],
	"./en/surgery_config.json": [
		48861,
		8861
	],
	"./en/topbar_config.json": [
		2325,
		4706
	],
	"./en/translationEn.json": [
		42585,
		2585
	],
	"./en/treatmentPlan_config.json": [
		73997,
		3997
	],
	"./en/user_config.json": [
		36091,
		6091
	],
	"./es/MIS_report_config.json": [
		94979,
		4979
	],
	"./es/Packagebilling.json": [
		36841,
		6841
	],
	"./es/aiGrading_config.json": [
		80583,
		583
	],
	"./es/andrology_config.json": [
		13888,
		3888
	],
	"./es/appointment_form.json": [
		7162,
		7162
	],
	"./es/billing_config.json": [
		89680,
		9680
	],
	"./es/calendar.json": [
		31108,
		1108
	],
	"./es/cima.json": [
		48584,
		8584
	],
	"./es/clinic_config.json": [
		56913,
		6913
	],
	"./es/concent_config.json": [
		51403,
		1403
	],
	"./es/consent_config.json": [
		88923,
		8923
	],
	"./es/cryoThawing_config.json": [
		11900,
		1900
	],
	"./es/cryo_storage_embryo.json": [
		64652,
		4652
	],
	"./es/cryo_storage_oocyte.json": [
		48439,
		8439
	],
	"./es/cryo_storage_sperm.json": [
		85517,
		5517
	],
	"./es/culture_config.json": [
		19735,
		9735
	],
	"./es/cycleOverview_config.json": [
		7434,
		7434
	],
	"./es/dashboard_config.json": [
		74313,
		4313
	],
	"./es/documents_config.json": [
		85003,
		5003
	],
	"./es/examination_config.json": [
		78434,
		8434
	],
	"./es/expired_return.json": [
		49689,
		2070
	],
	"./es/general.json": [
		8022,
		8022
	],
	"./es/grn_config.json": [
		51086,
		1086
	],
	"./es/grn_return.json": [
		24454,
		4454
	],
	"./es/hpi_config.json": [
		91860,
		9479
	],
	"./es/inventory_approval_config.json": [
		52143,
		2143
	],
	"./es/investigation_config.json": [
		20607,
		607
	],
	"./es/invoice_gallery.json": [
		63844,
		3844
	],
	"./es/issue_return.json": [
		53196,
		3196
	],
	"./es/login.json": [
		89151,
		9151
	],
	"./es/material_consumption.json": [
		90655,
		655
	],
	"./es/material_information.json": [
		69466,
		9466
	],
	"./es/medicalHistorySummary_config.json": [
		71323,
		3704
	],
	"./es/medicalHistory_config.json": [
		66670,
		6670
	],
	"./es/medicalHistrorySummary_config.json": [
		7256,
		7256
	],
	"./es/oocyte_grading.json": [
		72324,
		2324
	],
	"./es/outcome_config.json": [
		72893,
		2893
	],
	"./es/patientList_config.json": [
		23702,
		3702
	],
	"./es/pgt_config.json": [
		30296,
		296
	],
	"./es/purchase_order.json": [
		35046,
		5046
	],
	"./es/purchase_requisition.json": [
		74898,
		4898
	],
	"./es/receive_return.json": [
		85626,
		5626
	],
	"./es/registration_lang.json": [
		44272,
		4272
	],
	"./es/registration_patient_details.json": [
		61884,
		1884
	],
	"./es/return_config.json": [
		15091,
		5091
	],
	"./es/rfid_config.json": [
		77954,
		7954
	],
	"./es/sales_return.json": [
		51549,
		1549
	],
	"./es/sidebar_config.json": [
		49733,
		9733
	],
	"./es/stimulation_config.json": [
		52958,
		2958
	],
	"./es/stockTransfer_config.json": [
		85714,
		5714
	],
	"./es/stock_adjustment_config.json": [
		8201,
		8201
	],
	"./es/stock_config.json": [
		49539,
		9539
	],
	"./es/surgery_config.json": [
		97224,
		7224
	],
	"./es/topbar_config.json": [
		20801,
		801
	],
	"./es/translationEs.json": [
		34189,
		4189
	],
	"./es/treatmentPlan_config.json": [
		57428,
		7428
	],
	"./es/user_config.json": [
		69584,
		9584
	],
	"./hi/MIS_report_config.json": [
		55428,
		5428
	],
	"./hi/Packagebilling.json": [
		3492,
		3492
	],
	"./hi/aiGrading_config.json": [
		97982,
		7982
	],
	"./hi/andrology_config.json": [
		79261,
		9261
	],
	"./hi/appointment_form.json": [
		39091,
		9091
	],
	"./hi/billing_config.json": [
		32325,
		2325
	],
	"./hi/calendar.json": [
		31513,
		1513
	],
	"./hi/cima.json": [
		90529,
		529
	],
	"./hi/clinic_config.json": [
		222,
		222
	],
	"./hi/concent_config.json": [
		88450,
		8450
	],
	"./hi/consent_config.json": [
		14354,
		4354
	],
	"./hi/cryoThawing_config.json": [
		1097,
		1097
	],
	"./hi/cryo_storage_embryo.json": [
		73163,
		3163
	],
	"./hi/cryo_storage_oocyte.json": [
		69980,
		9980
	],
	"./hi/cryo_storage_sperm.json": [
		94464,
		4464
	],
	"./hi/culture_config.json": [
		10053,
		2434
	],
	"./hi/cycleOverview_config.json": [
		97447,
		7447
	],
	"./hi/dashboard_config.json": [
		73028,
		3028
	],
	"./hi/documents_config.json": [
		49486,
		9486
	],
	"./hi/examination_config.json": [
		67703,
		7703
	],
	"./hi/expired_return.json": [
		62555,
		2555
	],
	"./hi/general.json": [
		44865,
		4865
	],
	"./hi/grn_config.json": [
		80831,
		831
	],
	"./hi/grn_return.json": [
		6999,
		6999
	],
	"./hi/hpi_config.json": [
		74041,
		4041
	],
	"./hi/inventory_approval_config.json": [
		17748,
		7748
	],
	"./hi/investigation_config.json": [
		96666,
		6666
	],
	"./hi/invoice_gallery.json": [
		87111,
		7111
	],
	"./hi/issue_return.json": [
		65741,
		5741
	],
	"./hi/login.json": [
		4708,
		4708
	],
	"./hi/material_consumption.json": [
		7778,
		7778
	],
	"./hi/material_information.json": [
		96775,
		6775
	],
	"./hi/medicalHistorySummary_config.json": [
		99689,
		9689
	],
	"./hi/medicalHistory_config.json": [
		60149,
		149
	],
	"./hi/medicalHistrorySummary_config.json": [
		13655,
		3655
	],
	"./hi/oocyte_grading.json": [
		20845,
		845
	],
	"./hi/outcome_config.json": [
		49360,
		9360
	],
	"./hi/patientList_config.json": [
		85327,
		5327
	],
	"./hi/pgt_config.json": [
		98061,
		8061
	],
	"./hi/purchase_order.json": [
		88119,
		8119
	],
	"./hi/purchase_requisition.json": [
		29919,
		9919
	],
	"./hi/receive_return.json": [
		92707,
		2707
	],
	"./hi/registration_lang.json": [
		60159,
		159
	],
	"./hi/registration_patient_details.json": [
		34577,
		4577
	],
	"./hi/return_config.json": [
		2384,
		2384
	],
	"./hi/rfid_config.json": [
		65781,
		5781
	],
	"./hi/sales_return.json": [
		76960,
		6960
	],
	"./hi/sidebar_config.json": [
		32532,
		2532
	],
	"./hi/stimulation_config.json": [
		78007,
		8007
	],
	"./hi/stockTransfer_config.json": [
		34007,
		4007
	],
	"./hi/stock_adjustment_config.json": [
		34970,
		4970
	],
	"./hi/stock_config.json": [
		33950,
		3950
	],
	"./hi/surgery_config.json": [
		14205,
		4205
	],
	"./hi/topbar_config.json": [
		71810,
		1810
	],
	"./hi/translationHi.json": [
		21333,
		1333
	],
	"./hi/treatmentPlan_config.json": [
		47533,
		7533
	],
	"./hi/user_config.json": [
		30427,
		427
	],
	"./pt/MIS_report_config.json": [
		21787,
		1787
	],
	"./pt/Packagebilling.json": [
		35921,
		5921
	],
	"./pt/aiGrading_config.json": [
		73535,
		3535
	],
	"./pt/andrology_config.json": [
		80152,
		152
	],
	"./pt/appointment_form.json": [
		65506,
		5506
	],
	"./pt/billing_config.json": [
		40904,
		904
	],
	"./pt/calendar.json": [
		33644,
		3644
	],
	"./pt/cima.json": [
		83024,
		3024
	],
	"./pt/clinic_config.json": [
		94985,
		4985
	],
	"./pt/concent_config.json": [
		40387,
		387
	],
	"./pt/consent_config.json": [
		62483,
		2483
	],
	"./pt/cryoThawing_config.json": [
		5780,
		5780
	],
	"./pt/cryo_storage_embryo.json": [
		5252,
		5252
	],
	"./pt/cryo_storage_oocyte.json": [
		47215,
		7215
	],
	"./pt/cryo_storage_sperm.json": [
		39573,
		9573
	],
	"./pt/culture_config.json": [
		74895,
		4895
	],
	"./pt/cycleOverview_config.json": [
		78770,
		8770
	],
	"./pt/dashboard_config.json": [
		90705,
		705
	],
	"./pt/documents_config.json": [
		89059,
		9059
	],
	"./pt/examination_config.json": [
		32058,
		2058
	],
	"./pt/expired_return.json": [
		67630,
		7630
	],
	"./pt/general.json": [
		4814,
		4814
	],
	"./pt/grn_config.json": [
		91878,
		1878
	],
	"./pt/grn_return.json": [
		18430,
		8430
	],
	"./pt/hpi_config.json": [
		2908,
		2908
	],
	"./pt/inventory_approval_config.json": [
		32807,
		2807
	],
	"./pt/investigation_config.json": [
		3527,
		3527
	],
	"./pt/invoice_gallery.json": [
		49820,
		9820
	],
	"./pt/issue_return.json": [
		1860,
		1860
	],
	"./pt/login.json": [
		88439,
		820
	],
	"./pt/material_consumption.json": [
		94983,
		4983
	],
	"./pt/material_information.json": [
		37522,
		7522
	],
	"./pt/medicalHistorySummary_config.json": [
		43152,
		3152
	],
	"./pt/medicalHistory_config.json": [
		12982,
		2982
	],
	"./pt/medicalHistrorySummary_config.json": [
		20272,
		272
	],
	"./pt/oocyte_grading.json": [
		21612,
		1612
	],
	"./pt/outcome_config.json": [
		44034,
		1653
	],
	"./pt/patientList_config.json": [
		86558,
		6558
	],
	"./pt/pgt_config.json": [
		10400,
		400
	],
	"./pt/purchase_order.json": [
		18078,
		8078
	],
	"./pt/purchase_requisition.json": [
		458,
		458
	],
	"./pt/receive_return.json": [
		22322,
		2322
	],
	"./pt/registration_lang.json": [
		27256,
		4875
	],
	"./pt/registration_patient_details.json": [
		18404,
		8404
	],
	"./pt/return_config.json": [
		84507,
		4507
	],
	"./pt/rfid_config.json": [
		79338,
		9338
	],
	"./pt/sales_return.json": [
		78261,
		8261
	],
	"./pt/sidebar_config.json": [
		21533,
		1533
	],
	"./pt/stimulation_config.json": [
		73030,
		3030
	],
	"./pt/stockTransfer_config.json": [
		89002,
		9002
	],
	"./pt/stock_adjustment_config.json": [
		20193,
		193
	],
	"./pt/stock_config.json": [
		45675,
		5675
	],
	"./pt/surgery_config.json": [
		34112,
		4112
	],
	"./pt/topbar_config.json": [
		99241,
		9241
	],
	"./pt/translationPt.json": [
		53405,
		3405
	],
	"./pt/treatmentPlan_config.json": [
		18396,
		8396
	],
	"./pt/user_config.json": [
		55464,
		5464
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72096;
module.exports = webpackAsyncContext;